<ion-content [fullscreen]="true">
  <div class="bg">
    <app-background [marginTop]="50" [koffer]="true"></app-background>
  </div>
</ion-content>
